module.exports = __webpack_public_path__ + "assets/img/service-QRcord-pjl.d85ab674.jpg";